import { SIGN_IN_EN_H5_SOURCE_MAP, SIGN_IN_EN_WEB_SOURCE_MAP } from "../const"

export function resolveBaseUrl(
  baseUrl: string,
  url: string | URL | Location | undefined = getCurrentLocation()
): string {
  if (!isTestPageUrl(url)) return baseUrl

  const parsed = new URL(baseUrl)
  parsed.hostname = `test${parsed.hostname}`
  return parsed.toString().replace(/\/$/, "")
}

function getCurrentLocation(): Location | undefined {
  if (typeof window === "undefined") return undefined
  return window.location
}

function isTestPageUrl(url: string | URL | Location | undefined): boolean {
  return getHostname(url).toLowerCase().startsWith("test")
}

function getHostname(url: string | URL | Location | undefined): string {
  if (!url) return ""
  if (url instanceof URL) return url.hostname
  if (typeof url !== "string") return url.hostname

  try {
    return new URL(url).hostname
  } catch {
    return url
  }
}

export const isMobile = (): boolean => {
  if (typeof navigator === "undefined") return false
  const userAgent = navigator.userAgent.toLowerCase()
  const isHarmony = /OpenHarmony/i.test(userAgent)
  const isHarmonyPhone = isHarmony && /(Phone|Mobile)/i.test(userAgent)
  if (
    userAgent.match(
      /(phone|iPhone|iPod|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    ) ||
    isHarmonyPhone
  ) {
    return true
  }

  return false
}

export const resolveSource = (configuredSource?: string): string => {
  if (configuredSource) return configuredSource
  if (typeof window === "undefined") return ""
  const map = isMobile() ? SIGN_IN_EN_H5_SOURCE_MAP : SIGN_IN_EN_WEB_SOURCE_MAP
  const host = window.location.hostname
  const realHost = host?.replace(/^test/, "")
  return map[realHost] ?? ""
}

export const getUrlParam = (href?: string): string | null => {
  if (!href) return null
  return new URL(href).searchParams.get("url")
}

type ProfileCompletePhone = {
  phoneCode: string
  phoneNumber: string
}

export const buildProfileCompleteUrl = (
  userCenterUrl: string,
  locale: string,
  returnUrl: string | null,
  phone?: ProfileCompletePhone
): string => {
  const url = new URL(`/${locale}/profile-complete`, userCenterUrl)
  if (returnUrl) url.searchParams.set("url", returnUrl)
  if (phone) {
    url.searchParams.set("phoneCode", phone.phoneCode)
    url.searchParams.set("phoneNumber", phone.phoneNumber)
  }
  return url.href
}
